import React from 'react'
import Grid from '@material-ui/core/Grid/Grid'
import RestaurantConfiguration from '../../Component/Restaurant/Configuration'
import RestaurantMessage from '../../Component/Restaurant/Message'
import RestaurantProduit from '../../Component/Restaurant/Produit'
import GestionTable from '../../Component/Restaurant/GestionTable'
import Planning from '../../Component/Restaurant/Planning'
import Carcasse from '../../Component/Restaurant/Carcasse'
import Motif from '../../Component/Restaurant/Motif'
import Utils from 'EurestoFonction/Utils'
import Bus from 'EurestoClass/Bus'


export default (class extends React.Component {

  state = {
    UserTabSelected: 0,
    busGUID: Utils.uuidv4()
  }

  crmConfiguration = [
    {
      component: <Planning />
    },
    {
      component: <RestaurantProduit />
    },
    {
      component: <Motif type={1} />
    },
    {
      component: <Motif type={2} />
    },
    {
      component: <RestaurantMessage />
    },
    {
      component: <RestaurantConfiguration />
    },
    {
      component: <GestionTable />
    },
    {
      component: <Carcasse />
    },
  ]

  componentWillUnmount() {
    Bus.$off('donnees_annexes_restaurant', this.state.busGUID)
  }
  componentDidMount() {
    Bus.$on('donnees_annexes_restaurant', id => {
      this.setState({ UserTabSelected: id })
    }, this.state.busGUID)
  }

  render() {
    return <Grid container style={{ margin: 0, padding: 0, width: '100%', height: '100%' }} spacing={0}>
      <Grid item xs={12} style={{ margin: 0, padding: 0, width: '100%', height: '100%' }}>
        {
          this.crmConfiguration[this.state.UserTabSelected].component
        }
      </Grid>
    </Grid>
  }
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Page/Restaurant/index.js